$(document).ready(function () {
    if ( $('.animate-text').length ) {
      $('.animate-text span:not(.hero-letter-arrow)').each( function (i, span) {
        setTimeout( function () {
          $(span).addClass('active')
        }, 300 * i )
      })
    }

    if ( $('.module__content-viz').length ) {
      $('.module__content-viz .sub-nav__link').on('click', function (e) {
        e.preventDefault();
        const handle = $(this).attr('href')
        selectContentVizSection(handle)
      })
    }

})

function selectContentVizSection (handle) {  
  if ( !$(`#content-viz-link-${handle}`).closest('.sub-nav-item').hasClass('sub-nav-item--active') ) {
    $('.sub-nav-item--active').removeClass('sub-nav-item--active')
    $(`#content-viz-link-${handle}`).closest('.sub-nav-item').addClass('sub-nav-item--active')
    $('.content-viz__slide.active').removeClass('active')
    $(`#content-viz-${handle}`).addClass('active')
    $('#blog-categories').val(handle)
  }
}